import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity cursor-pointer">
            <i className="ri-bank-card-line text-orange-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
            <span className="text-xl font-bold text-gray-900">クレジットカード比較ナビ</span>
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-gray-700 hover:text-orange-600 transition-colors font-medium cursor-pointer whitespace-nowrap">
              ホーム
            </Link>
            <Link to="/ranking" className="text-gray-700 hover:text-orange-600 transition-colors font-medium cursor-pointer whitespace-nowrap">
              ランキング
            </Link>
            <Link to="/comparison" className="text-gray-700 hover:text-orange-600 transition-colors font-medium cursor-pointer whitespace-nowrap">
              比較
            </Link>
            <Link to="/diagnosis" className="text-gray-700 hover:text-orange-600 transition-colors font-medium cursor-pointer whitespace-nowrap">
              診断
            </Link>
            <a
              href="https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-2 rounded-lg hover:from-orange-600 hover:to-red-600 transition-all duration-300 font-semibold shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              公式サイトへ
            </a>
          </nav>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 hover:text-orange-600 transition-colors cursor-pointer"
            aria-label="メニュー"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl w-6 h-6 flex items-center justify-center`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col gap-4">
              <Link
                to="/"
                className="text-gray-700 hover:text-orange-600 transition-colors font-medium cursor-pointer whitespace-nowrap"
                onClick={() => setIsMenuOpen(false)}
              >
                ホーム
              </Link>
              <Link
                to="/ranking"
                className="text-gray-700 hover:text-orange-600 transition-colors font-medium cursor-pointer whitespace-nowrap"
                onClick={() => setIsMenuOpen(false)}
              >
                ランキング
              </Link>
              <Link
                to="/comparison"
                className="text-gray-700 hover:text-orange-600 transition-colors font-medium cursor-pointer whitespace-nowrap"
                onClick={() => setIsMenuOpen(false)}
              >
                比較
              </Link>
              <Link
                to="/diagnosis"
                className="text-gray-700 hover:text-orange-600 transition-colors font-medium cursor-pointer whitespace-nowrap"
                onClick={() => setIsMenuOpen(false)}
              >
                診断
              </Link>
              <a
                href="https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-2 rounded-lg hover:from-orange-600 hover:to-red-600 transition-all duration-300 font-semibold text-center whitespace-nowrap cursor-pointer"
              >
                公式サイトへ
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
